import useStory from "./useStory";

export default useStory;
